var _path, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H28C32.4183 0 36 3.58172 36 8V28C36 32.4183 32.4183 36 28 36H8C3.58172 36 0 32.4183 0 28V8Z",
    fill: "#006CE5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 13,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.576 24V23.216L17.256 23.008H18.072L19.72 23.216V24H15.576ZM16.648 24C16.6587 23.7013 16.664 23.3547 16.664 22.96C16.664 22.5653 16.664 22.16 16.664 21.744C16.6747 21.3173 16.68 20.9333 16.68 20.592V19.792C16.68 19.376 16.6747 19.0133 16.664 18.704C16.664 18.3947 16.6587 18.0747 16.648 17.744L15.464 17.648V16.944L18.264 16.016L18.696 16.128L18.664 18.272V20.592C18.664 20.9333 18.664 21.3173 18.664 21.744C18.664 22.16 18.664 22.5653 18.664 22.96C18.6747 23.3547 18.6853 23.7013 18.696 24H16.648ZM17.608 14.624C17.2667 14.624 16.9787 14.5173 16.744 14.304C16.5093 14.08 16.392 13.7973 16.392 13.456C16.392 13.1147 16.5093 12.8373 16.744 12.624C16.9787 12.4 17.2667 12.288 17.608 12.288C17.96 12.288 18.2533 12.4 18.488 12.624C18.7227 12.848 18.84 13.1253 18.84 13.456C18.84 13.7973 18.7227 14.08 18.488 14.304C18.2533 14.5173 17.96 14.624 17.608 14.624Z",
    fill: "#006CE5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.f8702eeabc818c163c0a5dd8755b655b.svg";
export { ForwardRef as ReactComponent };